import { CdkOverlayOrigin, ConnectedPosition, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Component, contentChildren, input, TemplateRef, viewChild, ViewContainerRef, ViewEncapsulation, inject } from '@angular/core';
import { ContentDropdownSubmenuCabinetComponent } from './content-dropdown-submenu.component';

@Component({
    selector: 'app-content-dropdown-cabinet',
    templateUrl: './content-dropdown.component.html',
    styleUrls: ['./content-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [CdkOverlayOrigin]
})
export class ContentDropdownCabinetComponent {
  private overlay = inject(Overlay);
  private viewContainerRef = inject(ViewContainerRef);

  trigger = viewChild.required(CdkOverlayOrigin);
  dropdownTemplate = viewChild.required<TemplateRef<unknown>>('dropdownTemplate');
  submenus = contentChildren(ContentDropdownSubmenuCabinetComponent);
  overlayRef!: OverlayRef;
  isOpen = false;

  title = input<string | undefined>(undefined);
  size = input<'xs' | 'sm' | 'lg' | undefined>(undefined);

  positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
      offsetX: 0,
      offsetY: 4
    },
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
      offsetX: 0,
      offsetY: -4
    },
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
      offsetX: 0,
      offsetY: 4
    },
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom',
      offsetX: 0,
      offsetY: -4
    }
  ];

  private closeDropdownBind = this.closeDropdown.bind(this);

  toggleDropdown(): void {
    this.isOpen ? this.closeDropdown() : this.openDropdown();
  }

  openDropdown(): void {
    if (!this.overlayRef) {
      const positionStrategy = this.overlay.position()
        .flexibleConnectedTo(this.trigger().elementRef)
        .withPositions(this.positions)
        .withFlexibleDimensions(false)
        .withPush(true)
        .withViewportMargin(10);

      this.overlayRef = this.overlay.create({
        positionStrategy,
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-transparent-backdrop'
      });

      this.overlayRef.backdropClick().subscribe(() => this.closeDropdown());
      this.overlayRef.overlayElement.addEventListener('click', this.closeDropdownBind);
      this.overlayRef.detachments().subscribe(() => this.isOpen = false);
    }

    const templatePortal = new TemplatePortal(this.dropdownTemplate(), this.viewContainerRef);
    this.overlayRef.attach(templatePortal);
    this.isOpen = true;
  }

  closeDropdown(): void {
    this.submenus().forEach(s => s.close());
    if (this.overlayRef) {
      this.overlayRef.detach();
    }
    this.isOpen = false;
  }
}
